import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Body5 } from '@ui';
import styled from 'styled-components';
import { colorPalette } from '@theme';

const DEFAULT_HANDLE_STYLE = {
  top: '26px',
  right: '4px',
  zIndex: 1000,
};
const Wrapper = styled.div`
  position: relative;
`;
const Label = styled.div`
  position: absolute;
  top: 17px;
  right: 14px;
  pointer-events: none;

  text-transform: uppercase;
  letter-spacing: -0.3px;

  * {
    font-size: 12px !important;
    color: ${colorPalette.primary.charcoal};
  }
`;

export default React.memo(({ data, isConnectable }) => {
  const id = 'query';
  const name = 'Query';

  return (
    <Wrapper>
      <Label>
        <Body5 bold uppercase>
          {name}
        </Body5>
      </Label>

      <Handle
        type="source"
        id={id}
        position={Position.Right}
        style={{
          background: colorPalette.primary.charcoal,
          cursor: isConnectable ? undefined : 'not-allowed',
          ...DEFAULT_HANDLE_STYLE,
        }}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
        isConnectableStart={isConnectable}
      />
    </Wrapper>
  );
});
